import {
    getFundRequests,
    addFundRequests,
    updateFundRequests,
    fetchFundRequestsById,
    getFundRequestsCount,
    getMercahntFundRequests,
    downloadFundRequestInvoice
  } from "../../services/FundRequestsService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const FUND_REQUESTS_LIST_INITIATED = "FUND_REQUESTS_LIST_INITIATED";
  export const FUND_REQUESTS_INITIATED = "FUND_REQUESTS_INITIATED";

  export const MERCHANT_FUND_REQUESTS_LIST_INITIATED = "MERCHANT_FUND_REQUESTS_LIST_INITIATED";
  export const MERCHANT_FUND_REQUESTS_INITIATED = "MERCHANT_FUND_REQUESTS_INITIATED";

  export const FUND_REQUESTS_LIST_LOADED = "FUND_REQUESTS_LIST_LOADED";
  export const FUND_REQUESTS_LOADED = "FUND_REQUESTS_LOADED";
  export const FUND_REQUESTS_FAILED = "FUND_REQUESTS_FAILED";
  export const FUND_REQUESTS_COUNT_INITIATED = "FUND_REQUESTS_COUNT_INITIATED";
  export const FUND_REQUESTS_COUNT_LOADED = "FUND_REQUESTS_COUNT_LOADED";
  export const FUND_REQUESTS_COUNT_FAILED  = "FUND_REQUESTS_COUNT_FAILED";
  export const FUND_REQUEST_INVOICE_DOWNLOAD_INITIATED = "FUND_REQUEST_INVOICE_DOWNLOAD_INITIATED";
  export const FUND_REQUEST_INVOICE_DOWNLOAD_LOADED = "FUND_REQUEST_INVOICE_DOWNLOAD_LOADED";
  export const FUND_REQUEST_INVOICE_DOWNLOAD_FAILED = "FUND_REQUEST_INVOICE_DOWNLOAD_FAILED";

  export const loadFundRequests = (getData) => {
    return (dispatch) => {
      dispatch({ type: FUND_REQUESTS_LIST_INITIATED });
      getFundRequests(getData)
        .then((response) => {
          dispatch({ type: FUND_REQUESTS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: FUND_REQUESTS_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantFundRequests = (id, getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_FUND_REQUESTS_LIST_INITIATED });
      getMercahntFundRequests(id, getData)
        .then((response) => {
          dispatch({ type: MERCHANT_FUND_REQUESTS_INITIATED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: FUND_REQUESTS_FAILED, payload: error.message });
        });
    };
  };

  export const loadFundRequestsCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: FUND_REQUESTS_COUNT_INITIATED });
      getFundRequestsCount(getData)
        .then((response) => {
          console.log('FUND_REQUESTS_COUNT_INITIATED', response.data)
          dispatch({ type: FUND_REQUESTS_COUNT_LOADED, payload: response.data.data[0] });
        })
        .catch((error) => {
          dispatch({ type: FUND_REQUESTS_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getFundRequestsById = (id) => {
    return (dispatch) => {
      dispatch({ type: FUND_REQUESTS_INITIATED });
      return fetchFundRequestsById(id)
        .then((response) => {
          dispatch({ type: FUND_REQUESTS_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: FUND_REQUESTS_FAILED, payload: formatError(error) });
        });
    };
  };
  
  
  
  export const downloadInvoice = (id, fileName) => {
    return async (dispatch) => {
      try {
        dispatch({ type: FUND_REQUEST_INVOICE_DOWNLOAD_INITIATED });
        const response = await downloadFundRequestInvoice(id);
        const name = fileName ? fileName : `invoice-${id}.pdf`;
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        dispatch({ type: FUND_REQUEST_INVOICE_DOWNLOAD_LOADED });
      } catch (error) {
        dispatch({
          type: FUND_REQUEST_INVOICE_DOWNLOAD_FAILED,
          payload: error.response?.data ? formatError(error.response.data) : formatError(error.message),
        });
      }
    };
  };

  export const saveFundRequestsAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: FUND_REQUESTS_INITIATED });
      const apiCall = isEdit ? updateFundRequests(id, data) : addFundRequests(data);
      return apiCall
        .then((response) => {
          formatSuccess('Fund Request', response.data)
          setTimeout(()=>{
            navigate('/fund-requests');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: FUND_REQUESTS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: FUND_REQUESTS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };